import { createAction } from '@reduxjs/toolkit';
import { AdminOverdueSortBy } from '../../../api/admin-overdue-exports/types';

export const setAdminOverdueSort = createAction<{ sort?: AdminOverdueSortBy }>('SET_ADMIN_OVERDUE_SORT');

export const setAdminOverduePage = createAction<number>('SET_ADMIN_OVERDUE_PAGE');

export const setAdminOverdueKeyword = createAction<string | undefined>('SET_ADMIN_OVERDUE_KEYWORD');
